import type { Action } from '~/actions'
import type { Nullable, Products, UpsellCart, Upsells } from '~/types'

interface State {
	products: Products | null
	error: string | null
	upsells: Upsells | null
	upsellCart: Nullable<UpsellCart>
}

const initialState: State = {
	products: null,
	error: null,
	upsells: null,
	upsellCart: null
}

export default function (state: State = initialState, action: Action): State {
	switch (action.type) {
		case 'PRODUCTS_LOAD_SUCCESS':
			return {
				...state,
				products: action.payload
			}

		case 'PRODUCTS_LOAD':
			return {
				...state,
				error: null
			}

		case 'PRODUCTS_LOAD_ERROR':
			return {
				...state,
				error: action.meta.message
			}

		case 'UPSELL_LOAD_SUCCESS':
			return {
				...state,
				upsells: action.payload
			}

		case 'UPSELL_CART_LOAD_SUCCESS':
			return {
				...state,
				upsellCart: action.payload
			}
	}
	return state
}
